import React from 'react'
import ReactDOM from 'react-dom'
import Card from '../shared-components/card.jsx'
import ItemsDataProvider from '../services/ItemsDataProvider.js';
import { Link } from 'react-router-dom';
import { markdown } from 'markdown';

const createDangerousMarkup = (text) => ({ __html: text });

const getAgeGroupTitle = (ageGroupKey, ageGroups) => {
    return (ageGroups.find(i => i.key === ageGroupKey)).text;
}

const getThemeTitle = (themeKey, themes) => {
    return (themes.find(i => i.key === themeKey)).text;
}

const Exercise = ({ exercise, themes, ageGroups }) => (
    <div className="row">
            <div className="nine-columns">
                <div className="exercise-head">
                    <h1 className="m-0">{exercise.title}</h1>
                    <span className="text-secondary">{exercise.firstName + ' ' + exercise.lastName || ''}</span>
                    <p>
                        {exercise.summary}
                    </p>

                    <div className="title-buttons-group row" style={{textAlign: 'center'}}>
                        <div style={{gap: 1 + `rem`}} className="four columns d-flex flex-column">
                            <div>Працягласць</div>
                            <i className="fa-solid fa-clock fa-2x"></i> 
                            <div>{exercise.length} хв.</div>
                        </div>
                        <div style={{gap: 1 + `rem`}} className="four columns d-flex flex-column">
                            <div>Прадмет</div>
                            <i className="fa-solid fa-person-chalkboard fa-2x"></i>
                            <div>{exercise.discipline}</div>
                        </div>
                        <div style={{gap: 1 + `rem`}} className="four columns d-flex flex-column">
                            <div>Мэтавая група</div>
                            <i className="fa-solid fa-people-group fa-2x"></i> 
                            <div>{getAgeGroupTitle(exercise.ageRange, ageGroups)}</div>
                        </div>
                    </div>


                </div>
                <div className="tab tab-main">
                    <div dangerouslySetInnerHTML={createDangerousMarkup(exercise.text)}></div>
                    <p>
                        <h5>Cпасылкі</h5>
                        <div>
                        {exercise.links.map(lnk => <a className="d-block" key={lnk.url} href={lnk.url}>{lnk.name}</a>)}
                        </div>
                    </p>
                    <p style={{ lineHeight: "1.5", display: "flex", gap: "2ch", flexWrap: "wrap"}}>
                            {exercise.themes.map((theme) => <Link className="mr-2" key={theme} to={`/exercise-list/?theme=${theme}`}>{`#` + getThemeTitle(theme, themes)}</Link>)}
                            {exercise.methods.map((method) => <Link key={method} to={`exercise-list/?method=${method}`}>{`#` + method}</Link>)}
                    </p>
                </div>
            </div>
            {/* <div className="four columns">
                <div className="tab tab-hardware">
                    <h3>Абсталяванне</h3>
                    {exercise.requirements}
                </div>
                <div className="tab tab-suggestion">
                    <h3>Парады</h3>
                    {exercise.tips}
                </div>
            </div> */}
        </div >
);

export default Exercise;